
const jobsCategorySelectJs = function () {

    $('.js--jobs-column').hover(function(){
        let colNumber = $(this).data('column');
        console.log('column ' + colNumber);

        $('.js--jobs-arrow').removeClass('is--visible');
        $('.js--arrow-' + colNumber).addClass('is--visible');

        $('.js--jobs-column').removeClass('is--visible');
        $('.js--column-' + colNumber).addClass('is--visible');

    });

    // js--jobs-arrow" data-arrow="{{ counter }}"
    // js--jobs-column" data-column="{{ counter }}"
    // js--arrow-{{ counter }}

}

export default jobsCategorySelectJs;
